import React from "react";
import BankAccountEditorScreen from "../../screens/profile-editor/BankAccountEditor";
import { MockedProvider } from "@apollo/client/testing/react";
import type { Meta, StoryObj } from "@storybook/react";
import { createStackNavigator } from "@react-navigation/stack";
import { StoryStackNavigatorContainer } from "../display-helpers";
import { AuthManagerContext, AuthStatus } from "../../contexts/AuthManager";
import { GET_BANK_DETAILS_FOR_IBAN } from "../../graphql/core";
import { UserFieldsFragment } from "../../__generated__/operations/graphql";

const POSTFINANCE_IBAN = "CH7609000000123456789";

const Stack = createStackNavigator<{
    BankAccountEdit: undefined;
}>();

const user = {
    id: "1",
    firstName: "Camille",
    lastName: "Dupont",
    workerProfile: { id: "1", bankAccount: null },
} as unknown as UserFieldsFragment;

const mocks = [
    {
        request: { query: GET_BANK_DETAILS_FOR_IBAN, variables: { iban: POSTFINANCE_IBAN } },
        result: {
            data: {
                getBankDetailsForIban: {
                    __typename: "BankDetails",
                    bic: "POFICHBEXXX",
                    bankName: "PostFinance AG",
                },
            },
        },
        maxUsageCount: Number.POSITIVE_INFINITY,
    },
];

const StoryComponent = () => {
    return (
        <MockedProvider mocks={mocks}>
            <AuthManagerContext.Provider
                value={{
                    status: AuthStatus.In,
                    user,
                    appExpoPushToken: undefined,
                    setAppExpoPushToken: () => {},
                    addRefreshListener: () => () => {},
                    signInWithPhoneNumber: () => Promise.reject(new Error("story")),
                }}
            >
                <StoryStackNavigatorContainer>
                    <Stack.Navigator initialRouteName="BankAccountEdit">
                        <Stack.Screen
                            name="BankAccountEdit"
                            options={{ title: "Compte salaire" }}
                            // eslint-disable-next-line @typescript-eslint/no-explicit-any
                            component={BankAccountEditorScreen as any}
                        />
                    </Stack.Navigator>
                </StoryStackNavigatorContainer>
            </AuthManagerContext.Provider>
        </MockedProvider>
    );
};

const meta = {
    title: "Screens/Bank account editor",
    component: StoryComponent,
    argTypes: {},
} satisfies Meta<typeof StoryComponent>;

export default meta;

type Story = StoryObj<typeof meta>;

export const Default: Story = {};
